jQuery(document).on('ready', function() {

	class ResponsiveBackgroundImage {

		constructor(element) {
				this.element = element;
				this.img = element.querySelector('img');
				this.src = '';

				this.img.addEventListener('load', () => {
						this.update();
				});

				if (this.img.complete) {
						this.update();
				}
		}

		update() {
				let src = typeof this.img.currentSrc !== 'undefined' ? this.img.currentSrc : this.img.src;
				if (this.src !== src) {
						this.src = src;
						this.element.style.backgroundImage = 'url("' + this.src + '")';

				}
		}
	}

	let elements = document.querySelectorAll('[data-responsive-background-image]');
	for (let i=0; i<elements.length; i++) {
		new ResponsiveBackgroundImage(elements[i]);
	}

});


jQuery(document).on('ready', function() {

	// First things first
	var firstTabTitle = jQuery(".tabs > li:nth-of-type(1)");
	var firstTab = jQuery(".tab__container > li:nth-of-type(1)");

	firstTabTitle.addClass("visible");
	firstTab.addClass("visible");

	// Variables
	var clickedTab = jQuery(".tabs > .visible");
	var tabWrapper = jQuery(".tab__container");
	var visibleTab = tabWrapper.find(".visible");
	var visibleTabHeight = visibleTab.outerHeight();

	// Show tab on page load
	firstTab.show();

	// Set height of wrapper on page load
	tabWrapper.height(visibleTabHeight);

	jQuery(".tabs > li").on("click", function() {

		// Remove class from visible tab
		jQuery(".tabs > li").removeClass("visible");

		// Add class visible to clicked tab
		jQuery(this).addClass("visible");

		// Update clickedTab variable
		clickedTab = jQuery(".tabs .visible");

		// fade out visible tab
		visibleTab.fadeOut(250, function() {

			// Remove visible class all tabs
			jQuery(".tab__container > li").removeClass("visible");

			// Get index of clicked tab
			var clickedTabIndex = clickedTab.index();

			// Add class visible to corresponding tab
			jQuery(".tab__container > li").eq(clickedTabIndex).addClass("visible");

			// update new visible tab
			visibleTab = jQuery(".tab__container > .visible");

			// Update variable
			visibleTabHeight = visibleTab.outerHeight();

			// Animate height of wrapper to new tab height
			tabWrapper.stop().delay(50).animate({
				height: visibleTabHeight
			}, 500, function() {

				// Fade in visible tab
				visibleTab.delay(50).fadeIn(250);

			});
		});
	});

	jQuery(window).resize( function() {

		// update new visible tab
		visibleTab = jQuery(".tab__container > .visible");

		// Update variable
		visibleTabHeight = visibleTab.outerHeight();

		// Animate height of wrapper to new tab height
		tabWrapper.stop().delay(50).animate({
			height: visibleTabHeight
		}, 150, function() {

			// Fade in visible tab
			visibleTab.delay(50).fadeIn(150);

		});

	});

});


jQuery(document).on('ready', function() {

	var parents = jQuery('#main-nav .menu-item-has-children > a');

	parents.after( '<button class="accordion-toggle"><span></span></button>' );

	jQuery('.accordion-toggle').on('click', function(e) {
		jQuery(this).toggleClass('toggled');
		jQuery(this).next().toggleClass('open');
	});

});


jQuery(document).on('ready', function() {

	jQuery('.menu-icon').on('click', function(e) {
		jQuery('#hamburger').toggleClass('cross');
		jQuery('#nav_main').toggleClass('open');
	});

	function closeMenuForDesktop(x) {
		if(x.matches) {
			var isCrossed = jQuery('#hamburger').hasClass('cross');

			if(isCrossed) {
				jQuery('#hamburger').toggleClass('cross');
				jQuery('#nav_main').toggleClass('open');
			}
		}
	}

	function closeAccordionsForDesktop(x) {
		if(x.matches) {
			var possibleToggles = jQuery('.accordion-toggle');

			possibleToggles.each( function() {

				var isToggled = jQuery(this).hasClass('toggled');

				if(isToggled) {
					jQuery(this).toggleClass('toggled');
					jQuery(this).next().toggleClass('open');
				}
			});
		}
	}
	var x = window.matchMedia("(min-width: 820px)");
	closeMenuForDesktop(x);
	closeAccordionsForDesktop(x);
	x.addListener(closeMenuForDesktop);
	x.addListener(closeAccordionsForDesktop);


	jQuery(document).on('click', 'a[href="#page-content"]', function(e) {
		e.preventDefault();

		var $target = jQuery(this).attr('href');
		var time = 500;
		var scrollTop = jQuery(window).scrollTop();
		var sectionScrollTop = jQuery($target).offset().top;
		var distance =  Math.abs(scrollTop - sectionScrollTop);
		var newTime = (distance*time)/1500;

		jQuery("html, body").animate({
			scrollTop: sectionScrollTop + 2
		}, 400);

	});

	jQuery(window).scroll( function () {
		if (jQuery(document).scrollTop() <= 80) {
			jQuery('#header').removeClass('small');
		} else {
			jQuery('#header').addClass('small');
		}
	});

});


jQuery(document).on('ready', function() {
	jQuery('iframe[src*="youtube"]').parent().fitVids();
	jQuery('iframe[src*="vimeo"]').parent().fitVids();
});


jQuery(document).on('ready', function() {
	jQuery('.videos__slider').slick({
		slidesToShow: 1,
		focusOnSelect: true,
		dots: false,
		responsive: [
			{
				breakpoint: 810,
				settings: {
					arrows: true,
					dots: true,
					slidesToShow: 1
				}
			},
			{
				breakpoint: 500,
				settings: {
					arrows: true,
					dots: true,
					slidesToShow: 1
				}
			}
		]
	});

	jQuery('.videos__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		var current = jQuery(slick.$slides[currentSlide]);
		current.html(current.html());
	});
});

jQuery(document).on('ready', function() {

	jQuery('.slider__headshots ').slick({
		slidesToShow: 7,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '0px',
		asNavFor: '.slider__testimonials',
		responsive: [
			{
				breakpoint: 820,
				settings: {
					arrows: true,
					centerMode: true,
					centerPadding: '0px',
					slidesToShow: 5
				}
			},
			{
				breakpoint: 620,
				settings: {
					arrows: true,
					centerMode: true,
					centerPadding: '0px',
					slidesToShow: 3
				}
			}
		]
	});
	jQuery('.slider__testimonials').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
		arrows: false,
		asNavFor: '.slider__headshots '
	});

});


jQuery(document).on('ready', function() {

	fitty('.fit');

});